import React from "react";
import { useTranslation } from "react-i18next";
import useSkinPath from "src/hooks/useSkinPath";
import locationIcon from "src/assets/images/7.svg";
import usersGroupIcon from "src/assets/images/8.svg";
import { BookCardPropsType } from "./BookCardTypes";
import { GriffleCardButton, StyledGriffleBookCard } from "./GriffleBookCard.styles";
import { IconBook, IconArrowRight } from "src/modules/griffle/GriffleIcons";

const GriffleBookCard: React.FC<BookCardPropsType> = ({
  imgUrl,
  title,
  author,
  series,
  id,
  readingLevel,
  blankDetailsButton = false,
  buttonTitle,
  onBookClick,
  selectedBookId,
  setSelectedBookId,
  isSelected
}) => {
  const [t] = useTranslation();
  const { path } = useSkinPath();

  const handleClick = () => {
    if (onBookClick) {
      onBookClick(id, imgUrl);
    } else if (setSelectedBookId) {
      setSelectedBookId(id);
    }
  };

  const isCardSelected = isSelected || selectedBookId === id;

  return (
    <StyledGriffleBookCard
      className={isCardSelected ? "selected" : ""}
      onClick={handleClick}
      style={{ cursor: onBookClick ? "pointer" : "default" }}
    >
      <div className="card-cover">
        {imgUrl ? (
          <img src={imgUrl} alt={title} />
        ) : (
          <div className="cover-placeholder">
            <IconBook size={36} />
          </div>
        )}
      </div>

      <div className="card-body">
        <h2 className="card-title">{title}</h2>

        <div className="card-meta">
          {series && series.length > 0 && (
            <div className="card-meta-row">
              <img className="meta-icon" src={locationIcon} alt="" aria-hidden="true" />
              <span>
                {series.map((item, i) => (
                  <span key={item.tagId}>
                    {item.tagName}
                    {series.length > 1 && i + 1 !== series.length ? ", " : ""}
                  </span>
                ))}{" "}
                {t("library_book_card_series_label")}
              </span>
            </div>
          )}

          {author && author.length > 0 && (
            <div className="card-meta-row">
              <img className="meta-icon" src={usersGroupIcon} alt="" aria-hidden="true" />
              <span>
                {author.map((item, i) => (
                  <span key={item.tagId}>
                    {item.tagName}
                    {author.length > 1 && i + 1 !== author.length ? ", " : ""}
                  </span>
                ))}
              </span>
            </div>
          )}

          {readingLevel != null && (
            <div className="card-reading-level">
              <span>Level {readingLevel}</span>
            </div>
          )}
        </div>
      </div>

      <div className="card-footer">
        <GriffleCardButton to={path(`/book/${id}`)} target={blankDetailsButton ? "_blank" : undefined}>
          {buttonTitle ?? t("library_book_card_button_select_book_label")} <IconArrowRight size={13} />
        </GriffleCardButton>
      </div>
    </StyledGriffleBookCard>
  );
};

export default GriffleBookCard;
